<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card width-modal">
      <header class="modal-card-head">
        <p class="modal-card-title">{{titleModal}}</p>
        <button class="delete" aria-label="close" @click="cancel"></button>
      </header>
      <section class="modal-card-body" >
        <div v-if="loading" class="lds-dual-ring center"></div>
        <div class="has-text-centered" v-if="errorPdf">
          Error en el formato del documento
        </div>
        <object v-else :data="pdfData" type="application/pdf" class="full-size" scrollbar="1"></object>
      </section>
      <footer class="modal-card-foot">
        <button v-if="!hideCloseButton" class="button" @click="cancel">Cancelar</button>
      </footer>
    </div>
  </div>
</template>

<script>
import downloadFile from '@/mixins/downloadFile'

export default {
  name: 'PdfViewer',
  mixins: [downloadFile],
  props: {
    hdlOnClick: Function,
    cancel: {
      type: Function,
      default: () => {}
    },
    titleModal: {
      type: String,
      default: 'Document'
    },
    pdf: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: true
    },
    downloadButton: {
      type: Boolean,
      default: false
    },
    hideCloseButton: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      pdfData: '',
      errorPdf: false
    }
  },
  watch: {
    loading (value) {
      if (!value) {
        this.setPdf(this.pdf)
      }
    }
  },
  mounted () {
    window.addEventListener('keydown', this.handleEscapeKey)
    if (!this.loading) this.setPdf(this.pdf)
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.handleEscapeKey)
  },
  methods: {
    handleEscapeKey (event) {
      const isEscapeKey = event.key === 'Escape' || event.keyCode === 27
      if (!isEscapeKey) return
      this.cancel()
    },
    setPdf (data) {
      if (data) {
        const isUrl = data?.substr(0, 7) === 'http://' || data?.substr(0, 8) === 'https://'
        this.pdfData = !isUrl ? this.base64ToBlobUrl(data) : data
        this.errorPdf = false
      } else {
        this.errorPdf = true
      }
    },
    getFileName (url) {
      return url ? new URL(url).pathname.split('/').pop() : null
    },
    downloadFile (fileName) {
      const name = fileName === 'original' ? this.downloadName.original || this.getFileName(this.url) : this.getFileName(this.url)
      this.forceToDownloadUrl(this.url, name)
    }
  }
}
</script>
<style lang="scss" scoped>
.modal-card-title {
  width: 90%;
}
.width-modal {
  width: 80%;
  height: 90%;
}
.full-size {
  width: 100%;
  height: 100%;
}
.center {
  left: 50%;
  position: absolute;
  top: 50%;
}
</style>
